import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';
import { auth0Config } from './auth0-config';
import Landing from './components/Landing';
import LoginAuth0 from './components/LoginAuth0';
import AuthCallback from './components/AuthCallback';
import Dashboard from './components/Dashboard';
import ProtectedRoute from './components/ProtectedRoute';
import AbueloDashboard from './pages/AbueloDashboard';
import CompletarDatos from './components/CompletarDatos';

function App() {
  return (
    <Auth0Provider
      domain={auth0Config.domain}
      clientId={auth0Config.clientId}
      authorizationParams={{
        redirect_uri: `${window.location.origin}/callback`,
        audience: auth0Config.audience,
        scope: auth0Config.scope
      }}
    >
      <Router>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<LoginAuth0 />} />
          <Route path="/callback" element={<AuthCallback />} />
          <Route path="/abuelo/:id" element={<AbueloDashboard />} />
          
          <Route
            path="/completar-datos"
            element={
              <ProtectedRoute>
                <CompletarDatos />
              </ProtectedRoute>
            }
          />
          <Route
            path="/editar-abuelo/:id"
            element={
              <ProtectedRoute>
                <CompletarDatos />
              </ProtectedRoute>
            }
          />
          
          <Route 
            path="/dashboard" 
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } 
          />
        </Routes>
      </Router>
    </Auth0Provider>
  );
}

export default App;